export const Roles = Object.freeze({
    designer: 'Designer',
    reviewer: 'Reviewer',
    designLeader: 'DesignLeader',
    reviewLeader: 'ReviewLeader',
    labAdmin: 'LabAdmin',
    admin: 'Admin',
    doctor: 'Doctor',
} as const);

export type Role = (typeof Roles)[keyof typeof Roles];

export const AllRoles: Role[] = Object.values(Roles);

export const DesignerRoles: Role[] = [Roles.designer, Roles.designLeader];
